import React from "react";
import { Column, Row } from "@/shared/ui/Blocks";
import BucketScoreChart from "@/shared/charts/BucketScoreChart";
import {
  LSpanKey,
  LSpanColumnMidRanges,
} from "@/lib/leadership-span-bucket-score-parser";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { cn } from "@/shared/utils/shadcn";
import { SubtitleText, Title } from "@/shared/ui";

export interface LeadershipSpanDifferentiatorProps {
  dimension: DimensionWithScores;
  dimensionKey: LSpanKey;
  className?: string;
}

function LeadershipSpanDifferentiator({
  dimension,
  dimensionKey,
  className,
}: LeadershipSpanDifferentiatorProps) {
  const score = dimension.score?.value || 0;
  const { min, max } = LSpanColumnMidRanges[dimensionKey];

  return (
    <Row
      className={cn(
        "items-start gap-6 py-4 border-b border-gray-200 last:border-b-0",
        className
      )}
    >
      {/* Chart section - taking about 30% of the width */}
      <div className="flex-shrink-0 w-1/3">
        <BucketScoreChart
          score={score}
          minMidRange={min}
          maxMidRange={max}
          peopleScores={dimension.peopleScores}
        />
      </div>

      {/* Content section - taking remaining space */}
      <Column className="flex-1 gap-1">
        <p className="text-sm text-gray-700 leading-relaxed font-semibold">
          {dimension.title}
        </p>
        <SubtitleText size="small" color="grey">
          {dimension.description}
        </SubtitleText>
      </Column>
    </Row>
  );
}

export default LeadershipSpanDifferentiator;
